module.exports = __webpack_public_path__ + "static/media/boat-img-18.dd58cf72.jpg";